export enum POTypeEnum { 
   WITHSO ='WITH SO',
   WITHOUTSO ='WITH OUT SO'
}

export enum ItemFromEnum{
   SO= 'SO',
   PO='PO'
}